import isWsBlock from './is-ws-block';

const isCustomBlock = (element) =>
  !!element && isWsBlock(element) && element.hasAttribute('custom');

export default isCustomBlock;
